import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet,asyncUpdateValues } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class AddAccountValue extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if(values.accountValues!=undefined){
                    values.accountValues = values.accountValues.split('\n');
                }
                values['_id'] = this.props.item._id;
                await this.props.asyncUpdate(formatFormData(values));
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="账号">
                            {getFieldDecorator('accountValues', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请填写',
                                    },
                                ],
                            })(
                                <TextArea rows={15} placeholder="请添加账号" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={true}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.appAccount.list.reduce((a, b) => (b._id === state.appAccount.currentSelectId ? b : a), {}),
    isModalShow: state.appAccount.uiStatus.isUpdateShowValue,
    isLoading: state.appAccount.uiStatus.isLoadingValue,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShowValue: false })),
    asyncUpdate: contents => dispatch(asyncUpdateValues(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddAccountValue));



// WEBPACK FOOTER //
// ./pages/client/AppAccount/addAccountValue.js